export const issueResolutionNodes = view => [
  view.state.schema.nodes.form_label.create({id: 'resolution'}, view.state.schema.text('Resolution')),
  view.state.schema.nodes.form_select.create({
    id: 'resolution',
    name: 'resolution',
    settings: {
      values: [
        {
          "name": "Known error",
          "value": "Known error"
        },
        {
          "name": "Cannot reproduce",
          "value": "Cannot reproduce"
        },
        {
          "name": "Duplicate",
          "value": "Duplicate"
        },
        {
          "name": "Won't do",
          "value": "Won't do"
        },
        {
          "name": "Done",
          "value": "Done"
        }
      ]
    },
  })
];